import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
'& .NADButton':{
    fontWeight: 600,
    padding: theme.spacing(1.25, 1.5),
},
}));
export default StyledBox;